export default __webpack_public_path__ + "static/zixbe-097871415124ee0822b6e57a9e319cab.png";